<template>
    <div class="operating-container" v-if="text != null && text !== undefined && text !== ''">
        <div class="operating-header" @click="toggleExpand">
            <div class="title-info-row">
                <span class="title">병원 운영 시간</span>
                <div class="tooltip-wrapper">
                    <img style="width: 20px; height: 20px; display: block; cursor: pointer;" src="../../assets/info.png" @click.stop="showTooltip = !showTooltip" />
                    <div class="tooltip" v-if="showTooltip">
                        <span class="tooltip-text">병원이 실제로 운영되는 시간이에요. <br>예약 없이 방문해도 진료받을 수 있어요.</span>
                        <div class="tooltip-arrow"></div>
                    </div>
                </div>
            </div>
            <div class="expand-icon" :class="{ expanded: isExpanded }">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <path d="M4 7L10 13L16 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>

        <div class="content-wrapper" :class="{ expanded: isExpanded }">
            <p class="content-text">{{ text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OperatingHours',
    props: {
        text: {
            type: String,
            default: '월~금 09:00 ~ 18:00\n토요일 09:00 ~ 13:00\n일요일 및 공휴일 휴진\n점심시간 13:00 ~ 14:00'
        }
    },
    data() {
        return {
            isExpanded: false,
            showTooltip: false
        }
    },
    mounted() {
        this._onClickOutside = (e) => {
            if (this.showTooltip && !this.$el.querySelector('.tooltip-wrapper').contains(e.target)) {
                this.showTooltip = false;
            }
        };
        document.addEventListener('click', this._onClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this._onClickOutside);
    },
    methods: {
        toggleExpand() {
            this.isExpanded = !this.isExpanded
        }
    }
}
</script>

<style scoped>
.operating-container {
    padding: 20px 16px;
    width: 100%;
    border-radius: 6px;
    box-sizing: border-box;
    background: var(--gray-00, #FFF);
    box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
    margin-top: 16px;
}

.operating-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
}

.title {
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}

.title-info-row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
}

.expand-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
    color: #666;
}

.expand-icon.expanded {
    transform: rotate(180deg);
}

.content-wrapper {
    overflow: hidden;
    max-height: 80px;
    transition: max-height 0.3s ease;
}

.content-wrapper.expanded {
    max-height: 500px;
}

.content-text {
    color: var(--Gray-60, #6B7684);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin: 0;
    white-space: pre-line;
}

.tooltip-wrapper {
    position: relative;
}

.tooltip {
    position: absolute;
    top: 30px;
    left: 0;
    transform: translateX(-10%);
    border-radius: 6px;
    background: var(--Primary-20, #E5F0FC);
    display: inline-flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
    z-index: 10;
}

.tooltip-arrow {
    position: absolute;
    top: -6px;
    left: 10%;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid var(--Primary-20, #E5F0FC);
}

.tooltip-text {
    color: var(--color-wb-black, #000);
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}
</style>



// WEBPACK FOOTER //
// src/components/hospital/OperatingHours.vue